import { render, staticRenderFns } from "./RightNow.vue?vue&type=template&id=7da71a9e&"
import script from "./RightNow.vue?vue&type=script&lang=js&"
export * from "./RightNow.vue?vue&type=script&lang=js&"
import style0 from "./RightNow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports